// src/components/consent/AnalyticsGate.jsx
import React, { useEffect, useRef } from "react";
import { useConsent } from "../../context/ConsentContext";
import {
  enableGoogleAnalytics,
  disableGoogleAnalytics,
} from "../../utils/analytics/googleAnalytics";
import { enableHotjar, disableHotjar } from "../../utils/analytics/hotjar";

export default function AnalyticsGate() {
  const consent = useConsent();
  const prevEnabledRef = useRef(null);

  const enabled = !!(consent?.status === "set" && consent?.analytics);

  useEffect(() => {
    // Only react when consent is explicitly set
    if (consent?.status !== "set") return;

    // Avoid repeating side effects if nothing changed
    if (prevEnabledRef.current === enabled) return;
    prevEnabledRef.current = enabled;

    if (enabled) {
      enableGoogleAnalytics();
      enableHotjar();
    } else {
      // Best-effort disable (future-proof for “disable after consent revoked”)
      disableGoogleAnalytics();
      disableHotjar();
    }
  }, [consent?.status, enabled]);

  return null;
}
